<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" field-name="회사명(필수)" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert' }]" />

    <!--    위험성평가 정보-->
    <div>
      <vs-row class="mt-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 위험성평가 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공종명(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" class="w-full flex-1" :readonly="board.readonly" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작업내용(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else v-model="form.inputB_3" class="w-full flex-1" :readonly="board.readonly" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">평가일(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대상기간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }} &nbsp;~&nbsp; {{ form.inputB_9 }}</p>
          <div v-else class="w-full flex-1" style="display: flex; align-items: center">
            <date-selector v-model="form.inputB_8" :readonly="board.readonly" @change="checkDate(form.inputB_8)" />
            &nbsp;~&nbsp;
            <date-selector v-model="form.inputB_9" :readonly="board.readonly" @change="checkDate(form.inputB_9)" />
          </div>
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">예정공정표 첨부</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputB_10.fileName }}
          </p>
          <file-uploader :readonly="board.readonly" v-else v-model="form.inputB_10" class="w-full flex-1" />
        </div>
      </div>
    </div>

    <!--    위험성 평가표-->
    <table-risk-appraisal-ep class="mt-5" title="위험성평가표" :value="form.riskAppraisalList" @input="updateList" :isPrint="isPrint" :readonly="board.readonly" :hide-code-number="true" />

    <!-- 안전·보건관리자 검토의견 -->
    <table-risk-appraisal-ep-2 class="mt-5" title="안전·보건관리자 검토의견" v-model="form.riskAppraisalList2" :isPrint="isPrint" :readonly="board.readonly" />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="신축현장 점검" />

    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoListAfter" :is-print="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import TableRiskAppraisal from "@/components/TableRiskAppraisal";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TableRiskAppraisalEp from "@/components/TableRiskAppraisalEp.vue";
import TableRiskAppraisalEp2 from "@/components/TableRiskAppraisalEp2.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    TableRiskAppraisalEp,
    TableRiskAppraisalEp2,
    PhotoUploadGridModule,
    TableRiskAppraisal,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      inputB_2: { required },
      inputB_3: { required },
      inputB_4: { required },
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      important: false,
      deep: true,
      handler(value) {
        // const keys = Object.keys(this.form)
        // for (const key of keys) {
        //   if (value[key]) {
        //     this.form[key] = this.value[key]
        //   }
        // }
        value.summary = {
          수시위험성평가_사업장명: [],
          수시위험성평가_재해형태: [],
        };

        value.summary["수시위험성평가_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.riskAppraisalList) {
          value.summary["수시위험성평가_재해형태"].push({
            [data.input_3]: 1,
          });
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "방파제",

      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: {}, // file

        photoList: [],
        photoListAfter: [],
        fileList: [],
        riskAppraisalList: [],
        riskAppraisalList2: [],
        disasters: "",
      },
    };
  },
  methods: {
    updateList(list) {
      this.form.riskAppraisalList = list;

      this.form.disasters = "";
      for (const risk of this.form.riskAppraisalList) {
        this.form.disasters += `${risk.input_3} `;
      }
    },
    checkDate(input) {
      if (Date.parse(this.form.inputB_8) > Date.parse(this.form.inputB_9)) {
        if (input === this.form.inputB_8) {
          this.form.inputB_9 = this.form.inputB_8;
        } else {
          this.form.inputB_8 = this.form.inputB_9;
        }
      }
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.inputB_2.required) return "공종명을 반드시 입력해야 합니다";
        else if (!this.$v.form.inputB_3.required) return "작업내용을 반드시 입력해야 합니다";
        else if (!this.$v.form.inputB_4.required) return "평가일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
